<script>
  export default {
    name: 'PascalChove',
  }
</script>

<template>
  <h2>PASCAL CHÔVE</h2>
  <div id="bloc-pascal">
    <div id="bio">
      <p>
        Pascal Chôve est né le 17 février 1960. Après un baccalauréat en arts
        plastiques, il poursuit ses études à l'école d'arts appliqués Dupperé à
        Paris, où il obtient son diplôme de plasticien.
      </p>
      <p>
        Jusqu'en 1986, il peint de nombreuses peintures murales à Paris et en
        province. Il se consacra ensuite exclusivement à la peinture de chevalet
        puis à la sculpture.
      </p>
      <p>
        Il a eu un succès rapide et son art est exposé dans les plus grandes
        villes du monde.
        <br />
        Ses œuvres font maintenant partie des plus grandes collections privées.
      </p>
    </div>
  </div>

  <div id="bloc-expositions">
    <h2>EXPOSITIONS AU FIL DES ANS...</h2>

    <div id="expositions">
      <ul>
        <li>
          <p>
            2023: Exposition personnelle grange de Villeneuve,
            <span class="ville">Guérande</span>
          </p>
        </li>
        <li>
          <p>
            2022: Exposition personnelle grange de Villeneuve,
            <span class="ville">Guérande</span>
          </p>
        </li>
        <li>
          <p>
            2021: Exposition galerie Marciano
            <span class="ville">La Baule</span> et place des Vosges,
            <span class="ville">Paris</span>
          </p>
        </li>
        <li>
          <p>
            2020: Exposition permanente galerie Raugraff,
            <span class="ville">Nancy</span>
          </p>
        </li>
        <li>
          <p>
            2019: Galerie émotion plurielle, <span class="ville">La Baule</span>
          </p>
        </li>
        <li>
          <p>
            2018: Exposition permanente galerie Maner,
            <span class="ville">Pont-Aven</span>
          </p>
        </li>
        <li>
          <p>
            Juin 2016: Galeries Mickael Marciano,
            <span class="ville">Paris</span>
          </p>
        </li>
        <li>
          <p>De 2005 à 2018: Galeries Bartoux</p>
          <ul id="bartoux">
            <li>
              <p>
                <span class="fake-tab">2005: </span>
                <span class="ville">Londres</span>
              </p>
            </li>
            <li>
              <p>
                <span class="fake-tab">2005: </span>
                <span class="ville">Courchevel</span>
              </p>
            </li>
            <li>
              <p>
                <span class="fake-tab">2005: </span>
                <span class="ville">Paris</span>
              </p>
            </li>
            <li>
              <p>
                <span class="fake-tab">2005: </span>
                <span class="ville">Honfleur</span>
              </p>
            </li>
            <li>
              <p>
                <span class="fake-tab">2005: </span>
                <span class="ville">Megève</span>
              </p>
            </li>
            <li>
              <p>
                <span class="fake-tab">2005: </span>
                <span class="ville">New-York</span>
              </p>
            </li>
            <li>
              <p>
                <span class="fake-tab">2005: </span>
                <span class="ville">Saint-Paul-de-Vence</span>
              </p>
            </li>
            <li>
              <p>
                <span class="fake-tab">2005: </span>
                <span class="ville">Cannes</span>
              </p>
            </li>
            <li>
              <p>
                <span class="fake-tab">2005: </span>
                <span class="ville">Singapour</span>
              </p>
            </li>
          </ul>
        </li>
        <li>
          <p>
            2003: Exposition galerie New River,
            <span class="ville">Fort Lauderdale, Floride</span>
          </p>
        </li>
        <li>
          <p>
            <span class="fake-tab">2003:</span> Exposition de groupe galerie
            Richelieu,
            <span class="ville">Montréal</span>
          </p>
        </li>
        <li>
          <p>
            2002: Salon Art avec la galerie Michelle Boulet,
            <span class="ville">Miami, Floride</span>
          </p>
        </li>
        <li>
          <p>
            2001: Exposition personnelle, galerie Michelle Boulet,
            <span class="ville">Paris</span>
          </p>
        </li>
        <li>
          <p>
            1999: Exposition de groupe galerie Michelle Boulet,
            <span class="ville">Paris</span>
          </p>
        </li>
        <li>
          <p>
            1998: Exposition galerie Lumina,
            <span class="ville">New-York</span>
          </p>
        </li>
        <li>
          <p>
            1997: Exposition personnelle galerie Lumina Soho,
            <span class="ville">New-York</span>
          </p>
        </li>
        <li>
          <p>
            1996: Exposition galerie Lumina,
            <span class="ville">New-York</span>
          </p>
        </li>
        <li>
          <p>
            1994: Exposition galerie Van Waning,
            <span class="ville">Rotterdam</span>
          </p>
        </li>
        <li>
          <p>
            1993: Exposition personnelle galerie Pygmalion,
            <span class="ville">Saint-Nazaire</span>
          </p>
        </li>
        <li>
          <p>
            1992: Exposition galerie du Palais,
            <span class="ville">Nantes</span>
          </p>
        </li>
        <li>
          <p>
            <span class="fake-tab">1992:</span> Salon d'automne grand palais,
            <span class="ville">Paris</span>
          </p>
        </li>
        <li>
          <p>
            1991: Exposition à la Nationale des Beaux-Arts,
            <span class="ville">Paris</span>
          </p>
        </li>
        <li>
          <p>
            <span class="fake-tab">1992:</span> Salon d'automne,
            <span class="ville">Paris</span>
          </p>
        </li>
        <li>
          <p>
            <span class="fake-tab">1992:</span> Exposition personnelle« états
            d'âme» galerie d'art de la place Beauvau,
            <span class="ville">Paris</span>
          </p>
        </li>
        <li>
          <p>
            1998: Salon Comparaisons, Grand Palais,
            <span class="ville">Paris</span>
          </p>
        </li>
        <li>
          <p>
            <span class="fake-tab">1998:</span> Salon d'automne,
            <span class="ville">Paris</span>
          </p>
        </li>
        <li>
          <p>
            <span class="fake-tab">1998:</span> Exposition galerie Marbach,
            <span class="ville">Mulhouse</span>
          </p>
        </li>
        <li>
          <p>
            <span class="fake-tab">1998: </span>
            <span class="ville">Prix du public, salon de Montmorency</span>
          </p>
        </li>
        <li>
          <p>
            1989: Exposition galerie d'art de la place Beauvau,
            <span class="ville">Paris</span>
          </p>
        </li>
        <li>
          <p>
            <span class="fake-tab">1989:</span> Exposition de groupe galerie de
            l'art ancien,
            <span class="ville">Orléans</span>
          </p>
        </li>
        <li>
          <p>
            <span class="fake-tab">1989:</span> Exposition personnelle galerie
            Marbach,
            <span class="ville">Mulhouse</span>
          </p>
        </li>
        <li>
          <p>
            1988: Exposition de groupe galerie d'art de la place Beauvau,
            <span class="ville">Paris</span>
          </p>
        </li>
        <li>
          <p>
            <span class="fake-tab">1988:</span> Exposition galerie du vieux
            moulin,
            <span class="ville">Tôt-Clères</span>
          </p>
        </li>
        <li>
          <p>
            <span class="fake-tab">1988:</span> Exposition galerie Marbach,
            <span class="ville">Mulhouse</span>
          </p>
        </li>
        <li>
          <p>
            <span class="fake-tab">1988:</span> Exposition salon de Monaco,
            <span class="ville">Prix de la ville de Monaco</span>
          </p>
        </li>
        <li>
          <p>
            <span class="fake-tab">1988:</span> Salon des indépendants,
            <span class="ville">Paris</span>
          </p>
        </li>
        <li>
          <p>
            <span class="fake-tab">1988:</span> Salon comparaisons,
            <span class="ville">Paris</span>
          </p>
        </li>
        <li>
          <p>
            <span class="fake-tab">1988:</span> Exposition théâtre de
            <span class="ville">Fontainebleau</span> sur le thème de« la ville»
          </p>
        </li>
        <li>
          <p>
            1987: Exposition personnelle galerie Karina,
            <span class="ville">Saint-Nazaire</span>
          </p>
        </li>
        <li>
          <p>
            1986:
            <span class="ville">Premier prix du salon de Concarneau </span>
          </p>
        </li>
        <li>
          <p>1985: Salons dans l'Ouest de la France</p>
        </li>
      </ul>
    </div>

    <ul class="galerie-pascal">
      <li>
        <img
          class="image"
          src="/visuels/pascal/pascal_chove_artiste_peintre_sculpteur_1.jpg"
          alt=""
        />
      </li>
      <li>
        <img
          class="image"
          src="/visuels/pascal/pascal_chove_artiste_peintre_sculpteur_6.jpg"
          alt=""
        />
      </li>
      <li>
        <img
          class="image"
          src="/visuels/pascal/pascal_chove_artiste_peintre_sculpteur_7.jpg"
          alt=""
        />
      </li>
      <li>
        <img
          class="image"
          src="/visuels/pascal/pascal_chove_artiste_peintre_sculpteur_4.jpg"
          alt=""
        />
      </li>
      <li>
        <img
          class="image"
          src="/visuels/pascal/pascal_chove_artiste_peintre_sculpteur_2.jpg"
          alt=""
        />
      </li>
      <li>
        <img
          class="image"
          src="/visuels/pascal/pascal_chove_artiste_peintre_sculpteur_3.jpg"
          alt=""
        />
      </li>
    </ul>
  </div>
</template>

<style scoped>
  .ville {
    font-weight: 600;
  }

  #bloc-pascal {
    width: min(90vw, 1200px);
    margin: 1.5em 0 2.5em 0;
  }
  #bio {
    text-align: start;
    margin: 1.5em 0;
  }
  #bio p {
    font-family: 'Rajdhani';
    font-size: 18px;
    font-weight: 400;
    line-height: 1.2;
  }

  #bloc-expositions {
    width: min(90vw, 1200px);
    background-color: rgb(242, 242, 242);
    padding: 2em 4em;
  }

  #expositions {
    margin: 2em;
  }
  #expositions * {
    list-style: none;
  }
  #expositions p {
    font-family: 'Rajdhani';
    font-size: 16px;
    text-align: start;
    line-height: 1.3;
  }
  #bartoux li p {
    line-height: 1.1;
  }
  .fake-tab {
    visibility: hidden;
  }

  .galerie-pascal {
    margin: 0;
    margin-block-start: 0;
    margin-block-end: 0;
    padding-inline-start: 0;
    width: 100%;
    display: grid;
    gap: 2em;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    list-style-type: none;
    margin-bottom: 2em;
  }
  .image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: flex;
    align-items: center;
  }

  @media (max-width: 768px) {
    #bloc-expositions {
      padding: 2em 8px;
    }

    .galerie-pascal {
      gap: 1em;
    }
  }
</style>
